import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-suspense',
  template: `
    <ng-container *ngIf="isLoading">
      <app-overlay-panel></app-overlay-panel>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <ng-content></ng-content>
    </ng-container>
  `,
  styleUrls: ['./suspense.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuspenseComponent {
  @Input() public isLoading: boolean = true;

  @HostBinding('class') @Input() public customView: string = '';
}
